// extracted by mini-css-extract-plugin
export default {"root":"IconCart_root__9R+1I"};